import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { useLabels } from 'wsm-common-data';
import { useFooterCTAs } from '../../../../hooks';

const MyCarsDetails = ({ link, onClick, isInline, title, isDesktop }) => {
	const labels = useLabels();
	const { footerHasMyCars } = useFooterCTAs();
	const ariaVehicleTitle = title ? title.join(' ') : '';
	const detailsAriaPreface = labels.get('DETAILS_FOR_THIS');
	const ariaLabel = `${detailsAriaPreface} ${ariaVehicleTitle}`;

	const detailsIconClasses = [
		'ddc-icon',
		'ddc-icon-arrow-details',
		isInline || !footerHasMyCars ? 'ml-2' : '',
		isDesktop ? 'ddc-icon-size-small' : ''
	];

	return (
		<a
			className={setClassNames([
				'modern-my-cars-details-label',
				'd-flex',
				'align-items-center',
				'p-0',
				'text-muted',
				isInline || !footerHasMyCars ? 'flex-row' : 'flex-column',
				isInline || !footerHasMyCars ? 'ml-auto' : ''
			])}
			href={link}
			onClick={onClick}
			aria-label={ariaLabel}
		>
			{!isInline && footerHasMyCars && (
				<i
					aria-hidden="true"
					className={setClassNames(detailsIconClasses)}
				/>
			)}
			<span>{labels.get('DETAILS')}</span>
			{(isInline || !footerHasMyCars) && (
				<i
					aria-hidden="true"
					className={setClassNames(detailsIconClasses)}
				/>
			)}
		</a>
	);
};

MyCarsDetails.propTypes = {
	link: PropTypes.string,
	onClick: PropTypes.func,
	isInline: PropTypes.bool,
	title: PropTypes.arrayOf(PropTypes.string),
	isDesktop: PropTypes.bool
};

export default MyCarsDetails;
